/**
 * MARKA PARCALARI — emailsunucum marka kiti v1.3 (palet: Mercan)
 *
 * Isaret SVG'si kitten birebir alindi. Renk `currentColor` uzerinden gelir ki
 * ayni yol hem mercan zeminde beyaz, hem acik zeminde mercan kullanilabilsin.
 */

const ISARET_YOL =
  "M12 26 H28 A8 8 0 1 0 20 34 H33 A10 10 0 0 0 43 24 A19 19 0 1 0 34.07 40.11";

export function Isaret({ boyut = 28, renk }: { boyut?: number; renk?: string }) {
  return (
    <svg
      viewBox="0 0 48 48"
      width={boyut}
      height={boyut}
      aria-hidden="true"
      style={{ display: "block", color: renk ?? "var(--brand)" }}
    >
      <path
        d={ISARET_YOL}
        fill="none"
        stroke="currentColor"
        strokeWidth="3.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Uygulama simgesi: mercan kare icinde beyaz isaret */
export function SimgeKare({ boyut = 30 }: { boyut?: number }) {
  return (
    <svg viewBox="0 0 48 48" width={boyut} height={boyut} aria-hidden="true" style={{ display: "block", flex: "none" }}>
      <rect width="48" height="48" rx="11" fill="var(--brand)" />
      <path
        d={ISARET_YOL}
        fill="none"
        stroke="#ffffff"
        strokeWidth="4.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Yatay kilit: isaret + kelime isareti.
 * `koyuZemin` yazinin beyaz olmasi gereken yerlerde kullanilir.
 */
export function Logo({ boyut = 26, koyuZemin = false }: { boyut?: number; koyuZemin?: boolean }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
      <Isaret boyut={boyut + 6} />
      <span
        style={{
          fontWeight: 800,
          fontSize: boyut * 0.78,
          letterSpacing: "-0.035em",
          color: koyuZemin ? "#fff" : "var(--n-900)",
          lineHeight: 1,
        }}
      >
        emailsunucum
      </span>
    </span>
  );
}

/** Urun adi — panelin kendi adi, sirket markasindan ayri */
export function UrunAdi({ koyuZemin = false }: { koyuZemin?: boolean }) {
  return (
    <span
      style={{
        fontSize: 11,
        letterSpacing: "0.09em",
        textTransform: "uppercase",
        color: koyuZemin ? "rgba(255,255,255,.62)" : "var(--n-500)",
        fontWeight: 600,
      }}
    >
      email panelim
    </span>
  );
}
